import { styled } from '@linaria/react';
import { fonts, primitives, semantic } from '../../theme/tokens';

export const StyledTextButton = styled.button`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-size: ${fonts.size.sm};

  &[data-size='xs'] {
    font-size: ${fonts.size.xs};
  }

  &[data-size='base'] {
    font-size: ${fonts.size.base};
  }

  &:hover {
    color: ${semantic.text.brand};
  }
`;
